import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=c3971dfc&scoped=true&"
import script from "./handle.vue?vue&type=script&setup=true&lang=js&"
export * from "./handle.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./handle.vue?vue&type=style&index=0&id=c3971dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3971dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3971dfc')) {
      api.createRecord('c3971dfc', component.options)
    } else {
      api.reload('c3971dfc', component.options)
    }
    module.hot.accept("./handle.vue?vue&type=template&id=c3971dfc&scoped=true&", function () {
      api.rerender('c3971dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/supplyChain/billInvoicing/handle.vue"
export default component.exports